import type { ZoneId } from '@wecasa/common/src/types/commons';
import type { Country } from '@wecasa/common/src/types/country';

type Config = {
  areHighlightedSlotsAvailable: boolean;
  // the tax credit is available in the country and we display the prices
  isTaxCreditAvailable: boolean;
  // only display info explaning the tax credit, prices are not impacted
  isTaxInfoDisplayed: boolean;
  // e-CESU is a FR-only prepaid scheme; the wallet endpoint only exists there
  isCesuAvailable: boolean;
};

export const CONFIG_BY_COUNTRY: Record<Country, Config> = {
  FR: {
    areHighlightedSlotsAvailable: true,
    isTaxCreditAvailable: true,
    isTaxInfoDisplayed: false,
    isCesuAvailable: true,
  },
  GB: {
    areHighlightedSlotsAvailable: false,
    isTaxCreditAvailable: false,
    isTaxInfoDisplayed: false,
    isCesuAvailable: false,
  },
  DE: {
    areHighlightedSlotsAvailable: false,
    isTaxCreditAvailable: false,
    isTaxInfoDisplayed: true,
    isCesuAvailable: false,
  },
  AT: {
    areHighlightedSlotsAvailable: false,
    isTaxCreditAvailable: false,
    isTaxInfoDisplayed: false,
    isCesuAvailable: false,
  },
  CH: {
    areHighlightedSlotsAvailable: false,
    isTaxCreditAvailable: false,
    isTaxInfoDisplayed: false,
    isCesuAvailable: false,
  },
};

type SetupFeeConfig = {
  zonesWithSetupFee: ZoneId[];
};

export const SETUP_FEE_CONFIG_BY_COUNTRY: Record<Country, SetupFeeConfig> = {
  FR: { zonesWithSetupFee: [] },
  GB: { zonesWithSetupFee: [2, 4, 5] },
  DE: { zonesWithSetupFee: [] },
  AT: { zonesWithSetupFee: [] },
  CH: { zonesWithSetupFee: [] },
};
